var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.$t(_vm.filterGroup.pageTitleLanguageKey).toString() ? _c('page-title', {
    attrs: {
      "title": _vm.$t(_vm.filterGroup.pageTitleLanguageKey).toString(),
      "subheading": "Gebruik de filters om de resultaten in te perken.",
      "icon": _vm.filterGroup.pageIcon
    }
  }) : _vm._e(), _vm.isLoadingFilters ? _c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  }) : _c('div', [_vm.headerComponent ? _c(_vm.headerComponent, _vm._b({
    tag: "component",
    staticClass: "mb-2"
  }, 'component', {
    filterGroup: _vm.filterGroup
  }, false)) : _vm._e(), !_vm.filterGroup.hideFilterCard ? _c('OmniCard', {
    staticClass: "pb-2",
    scopedSlots: _vm._u([{
      key: "header",
      fn: function () {
        return [_c('BCardTitle', [_c('b-row', [_c('b-col', {
          attrs: {
            "cols": "4",
            "sm": "10"
          }
        }, [_c('span', [_vm._v("Filters")])]), _c('b-col', {
          staticClass: "text-right font-weight-normal",
          attrs: {
            "cols": "8",
            "sm": "2"
          }
        }, [_c('a', {
          attrs: {
            "href": "#"
          },
          on: {
            "click": function ($event) {
              $event.preventDefault();
              _vm.filterConfig.filtersExpanded = !_vm.filterConfig.filtersExpanded;
            }
          }
        }, [_vm.filterConfig.filtersExpanded ? _c('span', [_vm._v("filters verbergen")]) : _c('span', [_vm._v("filters tonen")])])])], 1)], 1)];
      },
      proxy: true
    }, {
      key: "default",
      fn: function () {
        return [_c('div', {
          staticClass: "mb-4 lead"
        }, [_vm._l(_vm.nonEmptyFilterValues, function (filterDisplayValue, filterIdentifier) {
          return _c('b-badge', {
            key: JSON.stringify([filterIdentifier, filterDisplayValue]),
            staticClass: "font-weight-lighter font-size-md mr-3 mb-2",
            attrs: {
              "pill": "",
              "variant": "primary"
            }
          }, [_vm._v(" " + _vm._s(_vm.$t(`frontend-filters.${_vm.filterGroup.identifier}.filters.${filterIdentifier}.title`)) + ": "), _c('strong', {
            staticClass: "font-weight-bold",
            domProps: {
              "innerHTML": _vm._s(filterDisplayValue)
            }
          }), _vm.isFilterValueEditable(filterIdentifier.toString()) ? _c('a', {
            staticClass: "badge badge-pill badge-light ml-2 px-1 py-1",
            attrs: {
              "href": "#"
            },
            on: {
              "click": function ($event) {
                $event.preventDefault();
                _vm.removeFilterValue(filterIdentifier.toString());
              }
            }
          }, [_vm._v("×")]) : _c('a', {
            staticClass: "badge badge-pill invisible",
            attrs: {
              "href": "#"
            }
          }, [_vm._v(" ")])]);
        }), Object.keys(_vm.nonEmptyFilterValues).length === 0 ? _c('small', {
          staticClass: "d-block ml-4"
        }, [_c('i', [_vm._v("Geen filters ingesteld")])]) : _vm._e()], 2), _c('form', {
          ref: "filterForm",
          staticClass: "filter-form",
          on: {
            "submit": function ($event) {
              $event.preventDefault();
              return _vm.search(true);
            }
          }
        }, [_c('b-collapse', {
          attrs: {
            "id": "frontendFiltersCollapse"
          },
          model: {
            value: _vm.filterConfig.filtersExpanded,
            callback: function ($$v) {
              _vm.$set(_vm.filterConfig, "filtersExpanded", $$v);
            },
            expression: "filterConfig.filtersExpanded"
          }
        }, [_c('div', {
          staticClass: "filter-fields"
        }, _vm._l(_vm.visibleFilterFormFilters, function (filter) {
          return _c('div', {
            key: filter.identifier,
            staticClass: "filter-field"
          }, [_c('span', {
            staticClass: "label"
          }, [_vm._v(" " + _vm._s(_vm.$t(`frontend-filters.${_vm.filterGroup.identifier}.filters.${filter.identifier}.title`)) + " ")]), _c('FrontendFilterInput', {
            key: Object.keys(_vm.filterConfig.filterValues).indexOf(filter.identifier),
            staticClass: "input",
            attrs: {
              "filter": filter,
              "filter-group": _vm.filterGroup,
              "disabled": !_vm.isFilterValueEditable(filter.identifier)
            },
            model: {
              value: _vm.filterConfig.filterValues,
              callback: function ($$v) {
                _vm.$set(_vm.filterConfig, "filterValues", $$v);
              },
              expression: "filterConfig.filterValues"
            }
          })], 1);
        }), 0), _c('b-row', {
          staticClass: "mt-2"
        }, [_c('b-col', {
          attrs: {
            "cols": "8"
          }
        }, [_c('a', {
          attrs: {
            "href": "#"
          },
          on: {
            "click": function ($event) {
              $event.preventDefault();
              return _vm.resetFilters.apply(null, arguments);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('omt.gui.general.action.reset-filters')))]), _vm.hasPermission('debug.allowed') ? _c('span', [_vm._v(" | "), _c('a', {
          attrs: {
            "href": "#"
          },
          on: {
            "click": function ($event) {
              $event.preventDefault();
              _vm.consoleLog(JSON.stringify(_vm.filterConfig.filterValues));
            }
          }
        }, [_vm._v("dump filterwaardes")])]) : _vm._e(), _vm.hasPermission('debug.allowed') ? _c('span', [_vm._v(" | "), _c('a', {
          attrs: {
            "href": "#"
          },
          on: {
            "click": function ($event) {
              $event.preventDefault();
              _vm.consoleLog(JSON.stringify(_vm.filterConfig.availableFilterIdentifiers));
            }
          }
        }, [_vm._v("dump filter identifiers")])]) : _vm._e()]), _c('b-col', {
          staticClass: "text-right",
          attrs: {
            "cols": "4"
          }
        }, [_c('OmniButton', {
          attrs: {
            "type": "submit",
            "disabled": _vm.isSearching
          },
          on: {
            "click": _vm.debouncedFilterUpdate
          }
        }, [!_vm.isSearching ? _c('span', [_vm._v(_vm._s(_vm.$t('omt.gui.general.action.search')))]) : _c('font-awesome-icon', {
          attrs: {
            "icon": "spinner",
            "spin": ""
          }
        })], 1)], 1)], 1)], 1)], 1)];
      },
      proxy: true
    }], null, false, 1215824619)
  }) : _vm._e(), _c('div', {
    staticClass: "text-right font-weight-normal mr-2"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        _vm.isColumnsContainerExpanded = !_vm.isColumnsContainerExpanded;
      }
    }
  }, [_vm.isColumnsContainerExpanded ? _c('small', [_vm._v("kolommen verbergen")]) : _c('small', [_vm._v("kolommen tonen")])])]), _c('b-collapse', {
    model: {
      value: _vm.isColumnsContainerExpanded,
      callback: function ($$v) {
        _vm.isColumnsContainerExpanded = $$v;
      },
      expression: "isColumnsContainerExpanded"
    }
  }, [_c('OmniCard', {
    staticClass: "pb-4",
    scopedSlots: _vm._u([{
      key: "header",
      fn: function () {
        return [_c('BCardTitle', [_vm._v("KOLOMMEN")])];
      },
      proxy: true
    }, {
      key: "default",
      fn: function () {
        return [_c('OmniCheckboxes', {
          attrs: {
            "options": _vm.selectColumnsOptions,
            "draggable": "",
            "grid": false
          },
          model: {
            value: _vm.filterConfig.visibleColumnIdentifiers,
            callback: function ($$v) {
              _vm.$set(_vm.filterConfig, "visibleColumnIdentifiers", $$v);
            },
            expression: "filterConfig.visibleColumnIdentifiers"
          }
        }), _c('div', {
          staticClass: "mt-4"
        }, [_c('small', [_c('a', {
          attrs: {
            "href": "#"
          },
          on: {
            "click": function ($event) {
              $event.preventDefault();
              return _vm.resetColumns();
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('omt.gui.general.action.reset-to-defaults')))])]), _vm.hasPermission('debug.allowed') ? _c('small', [_vm._v(" | "), _c('a', {
          attrs: {
            "href": "#"
          },
          on: {
            "click": function ($event) {
              $event.preventDefault();
              _vm.consoleLog(JSON.stringify(_vm.filterConfig.visibleColumnIdentifiers));
            }
          }
        }, [_vm._v("dump kolommen")])]) : _vm._e()])];
      },
      proxy: true
    }])
  })], 1), _c('OmniCard', {
    staticClass: "pb-4",
    scopedSlots: _vm._u([{
      key: "header",
      fn: function () {
        return [_c('BCardTitle', [_vm._v(" RESULTATEN "), _vm.filterGroup.hideFilterCard ? _c('b-button', {
          staticClass: "p-0 ml-1",
          attrs: {
            "variant": "link",
            "size": "sm"
          },
          on: {
            "click": function ($event) {
              return _vm.search(true);
            }
          }
        }, [_c('font-awesome-icon', {
          staticClass: "text-secondary",
          attrs: {
            "icon": "rotate",
            "spin": _vm.isSearching
          }
        })], 1) : _vm._e()], 1)];
      },
      proxy: true
    }, {
      key: "default",
      fn: function () {
        return [_c('b-checkbox-group', {
          model: {
            value: _vm.selectedResults,
            callback: function ($$v) {
              _vm.selectedResults = $$v;
            },
            expression: "selectedResults"
          }
        }, [!_vm.isViewportSmall ? _c('b-table-simple', {
          staticClass: "search-results d-none d-sm-table",
          attrs: {
            "small": "",
            "borderless": ""
          }
        }, [_c('b-tr', [_vm.availableBatchActions.length ? _c('b-th', [!_vm.selectedResults.length ? _c('b-button', {
          staticClass: "p-0 ml-2",
          attrs: {
            "variant": "link",
            "title": _vm.$t('omt.gui.general.action.select-all')
          },
          on: {
            "click": _vm.toggleSelection
          }
        }, [_c('font-awesome-icon', {
          staticClass: "text-secondary",
          attrs: {
            "icon": "far fa-check-square"
          }
        })], 1) : _c('b-button', {
          staticClass: "p-0 ml-2",
          attrs: {
            "variant": "link",
            "title": _vm.$t('omt.gui.general.action.deselect-all')
          },
          on: {
            "click": _vm.toggleSelection
          }
        }, [_c('font-awesome-icon', {
          staticClass: "text-secondary",
          attrs: {
            "icon": "far fa-square"
          }
        })], 1), _c('b-dropdown', {
          attrs: {
            "size": "sm",
            "variant": "light",
            "disabled": !_vm.selectedResults.length
          },
          scopedSlots: _vm._u([{
            key: "button-content",
            fn: function () {
              return [_c('font-awesome-icon', {
                attrs: {
                  "icon": "bars"
                }
              })];
            },
            proxy: true
          }], null, false, 2205403328)
        }, _vm._l(_vm.batchActionsToShow, function (batchAction) {
          return _c('b-dropdown-item', {
            key: batchAction.identifier,
            attrs: {
              "disabled": !!_vm.currentExecutionBatchActionIdentifier
            }
          }, [_c('b-overlay', {
            attrs: {
              "show": _vm.currentExecutionBatchActionIdentifier === batchAction.identifier,
              "size": "sm"
            }
          }, [_c('b-button', {
            attrs: {
              "variant": "link",
              "size": "sm"
            },
            on: {
              "click": function ($event) {
                return _vm.executeBatchAction(batchAction);
              }
            }
          }, [_vm._v(_vm._s(_vm.$t(`frontend-filters.${_vm.filterGroup.identifier}.batch-actions.${batchAction.identifier}`)))])], 1)], 1);
        }), 1)], 1) : _vm._e(), _vm._l(_vm.visibleColumns, function (column) {
          var _vm$getColumnTranslat, _vm$getColumnTranslat2, _vm$getColumnTranslat3;
          return _c('b-th', {
            key: column.identifier
          }, [!_vm.showFilterInColumnHeader(column) ? [_c('span', {
            staticClass: "text-nowrap"
          }, [_vm._v(_vm._s((_vm$getColumnTranslat = _vm.getColumnTranslation(column.identifier, 'title')) !== null && _vm$getColumnTranslat !== void 0 ? _vm$getColumnTranslat : column.identifier))])] : [column.resultColumnFilterIdentifier && _vm.getFilterFromIdentifier(column.resultColumnFilterIdentifier) ? _c('FrontendFilterInput', {
            key: Object.keys(_vm.filterConfig.filterValues).indexOf(column.resultColumnFilterIdentifier),
            attrs: {
              "id": `column-filter-${column.identifier}`,
              "filter": /* @ts-ignore */_vm.getFilterFromIdentifier(column.resultColumnFilterIdentifier),
              "filter-group": _vm.filterGroup,
              "disabled": !_vm.isFilterValueEditable(column.resultColumnFilterIdentifier),
              "placeholder": (_vm$getColumnTranslat2 = _vm.getColumnTranslation(column.identifier, 'title')) !== null && _vm$getColumnTranslat2 !== void 0 ? _vm$getColumnTranslat2 : column.identifier,
              "is-inline": ""
            },
            model: {
              value: _vm.filterConfig.filterValues,
              callback: function ($$v) {
                _vm.$set(_vm.filterConfig, "filterValues", $$v);
              },
              expression: "filterConfig.filterValues"
            }
          }) : _vm._e(), _c('b-tooltip', {
            attrs: {
              "target": `column-filter-${column.identifier}`,
              "show": _vm.showColumnTooltip(column),
              "triggers": "blur",
              "custom-class": "frontend-filters-results-tooltip"
            },
            on: {
              "hide": function (e) {
                var _column$resultColumnF;
                return _vm.filterConfig.filterValues[(_column$resultColumnF = column.resultColumnFilterIdentifier) !== null && _column$resultColumnF !== void 0 ? _column$resultColumnF : ''] ? e.preventDefault() : void 0;
              }
            }
          }, [_vm._v(" " + _vm._s((_vm$getColumnTranslat3 = _vm.getColumnTranslation(column.identifier, 'title')) !== null && _vm$getColumnTranslat3 !== void 0 ? _vm$getColumnTranslat3 : column.identifier) + " ")])]], 2);
        })], 2), _vm._l(_vm.resultsWithParsedColumnValues, function (result) {
          return _c('b-tr', {
            key: JSON.stringify(result),
            class: _vm.getResultRowModifierCssClasses(result)
          }, [_vm.availableBatchActions.length ? _c('b-td', {
            staticClass: "text-center"
          }, [_vm.isResultRowSelectableForBatchAction(result) ? _c('b-checkbox', {
            attrs: {
              "value": result
            }
          }) : _vm._e()], 1) : _vm._e(), _vm._l(_vm.visibleColumns, function (column, index) {
            var _vm$filterGroup$getRe, _vm$filterGroup;
            return _c('b-td', {
              key: column.identifier
            }, [index === 0 ? _c('span', _vm._l(_vm.getResultRowModifierIcons(result), function (modifierIcon) {
              return _c('font-awesome-icon', {
                key: modifierIcon[0],
                staticClass: "mr-2",
                class: modifierIcon[1],
                attrs: {
                  "icon": modifierIcon[0],
                  "title": modifierIcon[2]
                }
              });
            }), 1) : _vm._e(), typeof result._columnValues[column.identifier] !== 'function' ? _c('span', [_vm.filterGroup.getResultLink ? _c('router-link', {
              staticClass: "text-dark",
              attrs: {
                "to": (_vm$filterGroup$getRe = (_vm$filterGroup = _vm.filterGroup).getResultLink) === null || _vm$filterGroup$getRe === void 0 ? void 0 : _vm$filterGroup$getRe.call(_vm$filterGroup, result, _vm.filterConfig.filterValues)
              },
              domProps: {
                "innerHTML": _vm._s(result._columnValues[column.identifier])
              }
            }) : _c('span', {
              domProps: {
                "innerHTML": _vm._s(result._columnValues[column.identifier])
              }
            })], 1) : _c(result._columnValues[column.identifier], _vm._b({
              tag: "component",
              on: {
                "resultsChanged": function ($event) {
                  return _vm.search(true);
                }
              }
            }, 'component', {
              resultRow: result
            }, false))], 1);
          })], 2);
        })], 2) : _vm._e()], 1), _vm._l(_vm.resultsWithParsedColumnValues, function (result) {
          var _vm$filterGroup$getRe2, _vm$filterGroup2;
          return _vm.isViewportSmall ? _c('b-card', {
            key: JSON.stringify(result),
            staticClass: "d-block d-sm-none mb-2",
            class: _vm.getResultRowModifierCssClasses(result)
          }, [_c('b-card-title', [_c('strong', [_c('router-link', {
            staticClass: "btn btn-sm btn-primary mr-2",
            attrs: {
              "tag": "button",
              "to": (_vm$filterGroup$getRe2 = (_vm$filterGroup2 = _vm.filterGroup).getResultLink) === null || _vm$filterGroup$getRe2 === void 0 ? void 0 : _vm$filterGroup$getRe2.call(_vm$filterGroup2, result, _vm.filterConfig.filterValues)
            }
          }, [_c('span', {
            staticClass: "fa fa-eye"
          })]), _vm._v(" " + _vm._s(result.order_identifier) + " ")], 1)]), _c('b-table-simple', _vm._l(_vm.visibleColumns, function (column) {
            var _vm$getColumnTranslat4, _vm$getColumnTranslat5, _vm$filterGroup$getRe3, _vm$filterGroup3;
            return _c('b-tr', {
              key: column.identifier
            }, [_c('b-th', {
              staticStyle: {
                "width": "50%"
              }
            }, [!_vm.showFilterInColumnHeader(column) ? [_c('span', [_vm._v(_vm._s((_vm$getColumnTranslat4 = _vm.getColumnTranslation(column.identifier, 'title')) !== null && _vm$getColumnTranslat4 !== void 0 ? _vm$getColumnTranslat4 : column.identifier))])] : [column.resultColumnFilterIdentifier && _vm.getFilterFromIdentifier(column.resultColumnFilterIdentifier) ? _c('FrontendFilterInput', {
              key: Object.keys(_vm.filterConfig.filterValues).indexOf(column.resultColumnFilterIdentifier),
              attrs: {
                "filter": /* @ts-ignore */_vm.getFilterFromIdentifier(column.resultColumnFilterIdentifier),
                "filter-group": _vm.filterGroup,
                "disabled": !_vm.isFilterValueEditable(column.resultColumnFilterIdentifier),
                "placeholder": (_vm$getColumnTranslat5 = _vm.getColumnTranslation(column.identifier, 'title')) !== null && _vm$getColumnTranslat5 !== void 0 ? _vm$getColumnTranslat5 : column.identifier
              },
              model: {
                value: _vm.filterConfig.filterValues,
                callback: function ($$v) {
                  _vm.$set(_vm.filterConfig, "filterValues", $$v);
                },
                expression: "filterConfig.filterValues"
              }
            }) : _vm._e()]], 2), _c('b-td', [typeof result._columnValues[column.identifier] !== 'function' ? _c('span', [_vm.filterGroup.getResultLink ? _c('router-link', {
              staticClass: "text-dark",
              attrs: {
                "to": (_vm$filterGroup$getRe3 = (_vm$filterGroup3 = _vm.filterGroup).getResultLink) === null || _vm$filterGroup$getRe3 === void 0 ? void 0 : _vm$filterGroup$getRe3.call(_vm$filterGroup3, result, _vm.filterConfig.filterValues)
              },
              domProps: {
                "innerHTML": _vm._s(result._columnValues[column.identifier])
              }
            }) : _c('span', {
              domProps: {
                "innerHTML": _vm._s(result._columnValues[column.identifier])
              }
            })], 1) : _c(result._columnValues[column.identifier], _vm._b({
              tag: "component",
              on: {
                "resultsChanged": function ($event) {
                  return _vm.search(true);
                }
              }
            }, 'component', {
              resultRow: result
            }, false))], 1)], 1);
          }), 1)], 1) : _vm._e();
        }), !_vm.isSearching && !_vm.results.length ? _c('div', [_c('i', [_vm._v("Geen resultaten")])]) : _vm.isSearching || _vm.isLoadingColumns ? _c('span', [_c('i', [_c('span', {
          staticClass: "fa fa-spinner fa-spin"
        }), _vm._v(" " + _vm._s(_vm.$t('omt.gui.general.label.is-searching')) + "...")]), _vm.isSearching ? _c('b-button', {
          staticClass: "ml-3 p-0",
          class: {
            'opacity-1': !_vm.showCancelButton
          },
          attrs: {
            "variant": "link",
            "size": "sm",
            "title": "Annuleren"
          },
          on: {
            "mouseenter": function ($event) {
              _vm.showCancelButton = true;
            },
            "mouseleave": function ($event) {
              _vm.showCancelButton = false;
            },
            "click": _vm.cancelSearch
          }
        }, [_c('font-awesome-icon', {
          staticClass: "text-danger",
          attrs: {
            "icon": "ban"
          }
        })], 1) : _vm._e()], 1) : _vm._e()];
      },
      proxy: true
    }])
  }), _c('b-modal', {
    attrs: {
      "id": "frontend-filters-batch-action-modal",
      "title": _vm.$t(`frontend-filters.${_vm.filterGroup.identifier}.batch-actions.${_vm.currentExecutionBatchActionIdentifier}`),
      "size": "xl",
      "hide-footer": ""
    },
    on: {
      "hidden": function ($event) {
        _vm.batchActionModalComponent = _vm.currentExecutionBatchActionIdentifier = null;
      }
    }
  }, [_c(_vm.batchActionModalComponent, {
    tag: "component",
    attrs: {
      "selected-results": _vm.selectedResults
    }
  })], 1), _c('div', {
    staticClass: "d-block d-sm-none mb-2",
    attrs: {
      "id": "viewportSmallTester"
    }
  }, [_vm._v(" ")]), _c('infinite-scroll', {
    attrs: {
      "show": !_vm.isSearching && !_vm.isLastPage
    },
    on: {
      "next": function ($event) {
        return _vm.search(false);
      }
    }
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }